/**
 * Utility functions for working with headshot images
 */

// Total number of headshots available
const TOTAL_HEADSHOTS = 11;

/**
 * Get a random headshot number between 1-11
 * @returns {number} A number between 1-11
 */
export const getRandomHeadshot = () => {
  return Math.floor(Math.random() * TOTAL_HEADSHOTS) + 1;
};

/**
 * Get a random headshot number, excluding a specific number
 * @param {number} exclude - The headshot number to exclude
 * @returns {number} A number between 1-11, different from the excluded number
 */
export const getRandomHeadshotExcluding = (exclude) => {
  let num;
  do {
    num = Math.floor(Math.random() * TOTAL_HEADSHOTS) + 1;
  } while (num === exclude);
  return num;
};

/**
 * Get multiple random unique headshots
 * @param {number} count - How many unique headshots to return
 * @returns {Array<number>} Array of unique headshot numbers
 */
export const getMultipleRandomHeadshots = (count) => {
  const selected = new Set();
  
  while (selected.size < Math.min(count, TOTAL_HEADSHOTS)) {
    selected.add(Math.floor(Math.random() * TOTAL_HEADSHOTS) + 1);
  }
  
  return Array.from(selected);
};

/**
 * Get the path to a headshot image
 * @param {number} num - The headshot number
 * @returns {string} The path to the headshot image
 */
export const getHeadshotPath = (num) => {
  return `/headshots/${num}.jpeg`;
};